import React from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import { withStyles } from '@material-ui/core/styles'
import CssBaseline from '@material-ui/core/CssBaseline'
import Drawer from '@material-ui/core/Drawer'
import List from '@material-ui/core/List'
import Divider from '@material-ui/core/Divider'
import IconButton from '@material-ui/core/IconButton'
import ChevronLeftIcon from '@material-ui/icons/ChevronLeft'
import {
  MainListItems,
  SecondaryListItems,
  LaundryListItems,
  InfoListItems,
  BookableObjectListItems,
  NewsFeedListItems,
  SettingsListItems
} from '../../common/ListItems'
import { compose } from 'recompose'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'

import SelectCommunityDialog from '../../containers/SelectCommunityDialog'
import Header from '../../containers/Header'

import introJs from 'intro.js'
import 'intro.js/introjs.css'

import InfoSettings from '../InfoSettings'
import LaundryBookings from '../LaundryBookings'
import LaundrySettings from '../LaundrySettings'
import Users from '../Users'
import BookingSystems from '../BookingSystems'
import NewsFeed from '../NewsFeed'
import PastBookings from '../PastBookings'
import Settings from '../Settings'

import * as CommunityActions from '../../actions/Communities'
import * as userActions from '../../actions/User'
import * as configActions from '../../actions/Config'
import * as Constants from '../../../helpers/Constants'
import * as Storages from '../../../helpers/Storages'
import * as Strings from './strings'

const drawerWidth = 280

class Dashboard extends React.Component {
  state = {
    open: true
  }

  renderContent() {
    const { config } = this.props

    switch (config.currentPage) {
      case Constants.USERS_PAGE:
        return <Users />
      case Constants.LAUNDRY_TIMES_PAGE:
        return <LaundrySettings />
      case Constants.INFO_SETTINGS_PAGE:
        return <InfoSettings />
      case Constants.LAUNDRY_BOOKINGS_PAGE:
        return <LaundryBookings />
      case Constants.BOOKING_SYSTEM_PAGE:
        return <BookingSystems />
      case Constants.NEWS_FEED_PAGE:
        return <NewsFeed />
      case Constants.PAST_BOOKINGS_PAGE:
        return <PastBookings />
      case Constants.SETTINGS_PAGE:
        return <Settings />
      default:
        return null
    }
  }

  componentDidMount() {
    const { user } = this.props

    this.props.tryGetCommunity(user.token)

    if (!Storages.getIntroShown()) {
      introJs().start()
      Storages.setIntroShown()
    }
  }

  render() {
    const { open } = this.state
    const { classes, history, data, user } = this.props

    if (!user.token) {
      history.push('/')

      return null
    }

    if (data.community) {
      const privileges = data.community.privileges

      return (
        <React.Fragment>
          <CssBaseline />
          <div className={classes.root}>
            <Header open={open} onClose={() => this.setState({ open: true })} />
            <Drawer
              variant={'permanent'}
              classes={{
                paper: classNames(
                  classes.drawerPaper,
                  !this.state.open && classes.drawerPaperClose
                )
              }}
              open={this.state.open}
            >
              <div className={classes.toolbarIcon}>
                <IconButton onClick={() => this.setState({ open: false })}>
                  <ChevronLeftIcon />
                </IconButton>
              </div>
              <Divider />
              <List>
                <MainListItems
                  onUsersPressed={() =>
                    this.props.setCurrentPage(Constants.USERS_PAGE)
                  }
                />
              </List>
              <Divider />
              {privileges.laundryBookingSystem ? (
                <div>
                  <List data-intro={Strings.default.LAUNDRY_INTRO}>
                    <LaundryListItems
                      onLaundryTimes={() =>
                        this.props.setCurrentPage(Constants.LAUNDRY_TIMES_PAGE)
                      }
                      onBooking={() =>
                        this.props.setCurrentPage(
                          Constants.LAUNDRY_BOOKINGS_PAGE
                        )
                      }
                    />
                  </List>
                  <Divider />
                </div>
              ) : null}
              {privileges.bookingSystem ? (
                <div>
                  <List data-intro={Strings.default.BOOKINGS_INTRO}>
                    <BookableObjectListItems
                      onBookableObjects={() =>
                        this.props.setCurrentPage(Constants.BOOKING_SYSTEM_PAGE)
                      }
                      onPastBookings={() =>
                        this.props.setCurrentPage(Constants.PAST_BOOKINGS_PAGE)
                      }
                    />
                  </List>
                  <Divider />
                </div>
              ) : null}
              {privileges.feedSystem ? (
                <div>
                  <List data-intro={Strings.default.FEED_INTRO}>
                    <NewsFeedListItems
                      onNewsFeed={() =>
                        this.props.setCurrentPage(Constants.NEWS_FEED_PAGE)
                      }
                    />
                  </List>
                  <Divider />
                </div>
              ) : null}
              {privileges.infoSystem ? (
                <div>
                  <List data-intro={Strings.default.INFO_INTRO}>
                    <InfoListItems
                      onInfoSettings={() =>
                        this.props.setCurrentPage(Constants.INFO_SETTINGS_PAGE)
                      }
                    />
                  </List>
                  <Divider />
                </div>
              ) : null}
              <List>
                <SettingsListItems
                  onSettings={() =>
                    this.props.setCurrentPage(Constants.SETTINGS_PAGE)
                  }
                />
              </List>
              <Divider />
              <List>
                <SecondaryListItems
                  onSignOut={() =>
                    this.props.showAlert(
                      Strings.default.SIGN_OUT,
                      Strings.default.SIGN_OUT_HEADER,
                      Constants.TWO_BUTTONS,
                      { title: Strings.default.NO, onPress: () => {} },
                      {
                        title: Strings.default.YES,
                        onPress: () => this.props.signOut()
                      }
                    )
                  }
                />
              </List>
            </Drawer>
            {this.renderContent()}
          </div>
        </React.Fragment>
      )
    }

    return <div />
  }
}

const Styles = theme => ({
  root: {
    display: 'flex'
  },
  toolbarIcon: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    padding: '0 8px',
    ...theme.mixins.toolbar
  },
  drawerPaper: {
    position: 'relative',
    whiteSpace: 'nowrap',
    width: drawerWidth,
    transition: theme.transitions.create('width', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen
    })
  },
  drawerPaperClose: {
    overflowX: 'hidden',
    transition: theme.transitions.create('width', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen
    }),
    width: theme.spacing.unit * 7,
    [theme.breakpoints.up('sm')]: {
      width: theme.spacing.unit * 9
    }
  }
})

Dashboard.propTypes = {
  classes: PropTypes.object.isRequired
}

function mapStateToProps({ data, config, user }) {
  return { data, config, user }
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    { ...configActions, ...userActions, ...CommunityActions },
    dispatch
  )
}

export default compose(
  withStyles(Styles),
  connect(mapStateToProps, mapDispatchToProps)
)(Dashboard)



// WEBPACK FOOTER //
// ./src/components/pages/Dashboard/index.js